import { Tag } from '@chakra-ui/react';

type FilterTagProps = {
  label: string;
  value: string;
  onRemove: () => void;
};

const FilterTag = ({ label, value, onRemove }: FilterTagProps) => (
  <Tag.Root size="lg" colorPalette="argos" variant="solid">
    <Tag.Label>
      <span style={{ fontSize: '0.75rem' }}>
        {label}:
      </span>
      {' '}
      <b>
        {value}
      </b>
    </Tag.Label>
    <Tag.EndElement>
      <Tag.CloseTrigger onClick={onRemove} cursor="pointer" />
    </Tag.EndElement>
  </Tag.Root>
);


export default FilterTag;
